import { createSlice } from "@reduxjs/toolkit";

const getInitialLgvObjectViewIsOpen = () => {
  if (typeof window !== "undefined") {
    const appSettings = JSON.parse(localStorage.getItem("appSettings") || "{}");
    return appSettings?.lgvObjects ?? true;
  }
};

const initialState = {
  plantDetails: {
    plantCode: "",
    plantTimeZone: "",
    plantMetaData: {}
  },
  timeRangeType: "",
  prodLines: {
    loading: true,
    data: []
  },
  battStations: {
    loading: true,
    data: []
  },
  dockDoors: {
    loading: true,
    data: []
  },
  nonLGVInventory: {
    loading: true,
    data: [],
    isModalOpen: false
  },
  //lgv
  lgvObjectViewIsOpen: getInitialLgvObjectViewIsOpen(),
  vehicleDataFromSocket: {
    loading: true,
    data: []
  },
  followingLgvList: {
    indoorMap: [],
    newTimeMachine: []
  },
  //racks
  rackStorage: { data: [], loading: true, count: {} },
  //blocks
  blockStorage: { data: [], loading: true, count: {} },
  //block & rack
  selectedBlockRackLocationData: {},
  //dock door utility
  enableDockDoor: true,
  dockDoorViewIsOpen: true,
  dockDoorMode: false,
  //production line
  enableProductionLine: true,
  productionLineViewIsOpen: true,
  //battery station
  enableBatteryStationObj: true
};

const plantSlice = createSlice({
  name: "plant",
  initialState,
  reducers: {
    setProdLinesData: (state, action) => {
      state.prodLines.data = action.payload;
      state.prodLines.loading = false;
    },
    setBattStationsData: (state, action) => {
      state.battStations.data = action.payload;
      state.battStations.loading = false;
    },
    setDockDoorsData: (state, action) => {
      state.dockDoors.data = action.payload;
      state.dockDoors.loading = false;
    },
    setNonLGVInventoryData: (state, action) => {
      state.nonLGVInventory.data = action.payload;
      state.nonLGVInventory.loading = false;
    },
    setIsNonLgvModalOpen: (state, action) => {
      state.nonLGVInventory.isModalOpen = action.payload;
    },
    setLgvObjectViewIsOpen: (state, action) => {
      state.lgvObjectViewIsOpen = action.payload;
    },
    setVehicleDataFromSocket: (state, action) => {
      state.vehicleDataFromSocket.data = action.payload;
      state.vehicleDataFromSocket.loading = false;
    },
    setFollowingLgvList: (state, action) => {
      const { feature, list } = action.payload;
      state.followingLgvList[feature] = list;
    },
    setRacksCount: (state, action) => {
      state.rackStorage.count = action.payload;
    },
    setRackStorageData: (state, action) => {
      state.rackStorage.data = action.payload;
      state.rackStorage.loading = false;
    },
    setBlockStorageData: (state, action) => {
      state.blockStorage.data = action.payload;
      state.blockStorage.loading = false;
    },
    setBlocksCount: (state, action) => {
      state.blockStorage.count = action.payload;
    },
    setSelectedBlockRackLocationData: (state, action) => {
      state.selectedBlockRackLocationData = action.payload;
    },
    setActivePlantCode: (state, action) => {
      state.plantDetails.plantCode = action.payload;
    },
    setPlantMetaData: (state, action) => {
      state.plantDetails.plantMetaData = action.payload;
    },
    setPlantTimeZone: (state, action) => {
      state.plantDetails.plantTimeZone = action.payload;
    },
    setTimeRangeType: (state, action) => {
      //utilised old TM, Heatmap, navQ modules
      state.timeRangeType = action.payload;
    },
    setEnableDockDoor: (state, action) => {
      state.enableDockDoor = action.payload;
    },
    setDockDoorViewIsOpen: (state, action) => {
      state.dockDoorViewIsOpen = action.payload;
    },
    setDockDoorMode: (state, action) => {
      state.dockDoorMode = action.payload;
    },
    setEnableProductionLine: (state, action) => {
      state.enableProductionLine = action.payload;
    },
    setProductionLineViewIsOpen: (state, action) => {
      state.productionLineViewIsOpen = action.payload;
    },
    setEnableBatteryStationObj: (state, action) => {
      state.enableBatteryStationObj = action.payload;
    }
  }
});

export const {
  setProdLinesData,
  setBattStationsData,
  setDockDoorsData,
  setNonLGVInventoryData,
  setIsNonLgvModalOpen,
  setLgvObjectViewIsOpen,
  setVehicleDataFromSocket,
  setFollowingLgvList,
  setRacksCount,
  setRackStorageData,
  setBlockStorageData,
  setBlocksCount,
  setSelectedBlockRackLocationData,
  setActivePlantCode,
  setPlantMetaData,
  setTimeRangeType,
  setPlantTimeZone,
  setEnableDockDoor,
  setDockDoorViewIsOpen,
  setDockDoorMode,
  setEnableProductionLine,
  setProductionLineViewIsOpen,
  setEnableBatteryStationObj
} = plantSlice.actions;

export default plantSlice.reducer;
